//region :: Imports ::
import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import PrimeReact from 'primereact/api';
import App from './App';
import './App.scss';
import LogoutPage from './Toolkit/Pages/LogoutPage';
import AITelemetryProvider from './Toolkit/Components/Logging/AITelemetryProvider';
import Environment from './Toolkit/Environment';
import ListRequestsPage from './Apps/Pages/ListRequestsPage';
import ListCrewsPage from './Apps/Pages/ListCrewsPage';
import CreateRequestPage from './Apps/Pages/CreateRequestPage';
import EditRequestPage from './Apps/Pages/EditRequestPage';
import CreateCrewPage from './Apps/Pages/CreateCrewPage';
import EditCrewPage from './Apps/Pages/EditCrewPage';
import AccessDeniedPage from './Toolkit/Pages/AccessDeniedPage';
import MAppContainer from './Toolkit/Components/Shell/AppContainer';
import DrawingSummaryPage from './Apps/Pages/DrawingSummaryPage';
import ListProjectsPage from './Apps/Pages/ListProjectsPage';
import Authorize from './Toolkit/Components/Auth/Authorize';
import ArchivePage from './Apps/Pages/ArchivePage';

//endregion

//  PrimeReact
PrimeReact.ripple = true;
PrimeReact.cssTransition = true;

//  Routes
let routes =
    <Routes>
        <Route path="/" element={<MAppContainer/>}>
            <Route path="" element={<App/>}>

                {/* Default */}
                <Route index element={<Navigate to="/requests"/>}/>
                {/* Demo */}
                {/*<Route path="navihome" element={<NaviHome/>}/>*/}
                {/*<Route path="bookings" element={<ListBookingsPage/>}/>*/}
                <Route path="requests" element={<ListRequestsPage/>}/>
                <Route path="archive" element={<ArchivePage/>}/>
                {/*<Route path="commercials" element={<ListCommercialsPage/>}/>*/}
                {/*<Route path="invoices" element={<InvoiceTrackerPage/>}/>*/}
                <Route path="drawings" element={<DrawingSummaryPage/>}/>
                <Route path="requests/create/:id" element={<CreateRequestPage/>}/>
                {/*<Route path="requests/job/:id" element={<CreateJobPage/>}/>*/}
                <Route path="requests/:id" element={<EditRequestPage/>}/>
                {/*<Route path="bookings/:id" element={<EditBookingPage/>}/>*/}
                {/*<Route path="commercials/:id" element={<EditCommercialPage/>}/>*/}
                <Route path="crews" element={<ListCrewsPage/>}/>
                <Route path="crews/create" element={<CreateCrewPage/>}/>
                <Route path="crews/:id" element={<EditCrewPage/>}/>
                {/*<Route path="dayView/" element={<DayViewPage/>}/>*/}
                {/*<Route path="calendarView/" element={<CalendarViewPage/>}/>*/}
                {/*<Route path="reports/" element={<ReportsPage/>}/>*/}
                <Route path="projects/" element={
                    <Authorize roles={['Supervisor']}>
                        <ListProjectsPage/>
                    </Authorize>
                }/>
            </Route>
            <Route path="access-denied" element={<AccessDeniedPage/>}/>
            <Route path="logout" element={<LogoutPage/>}/>
        </Route>
    </Routes>;

if(!Environment.isLocal) {
    routes = (
        <AITelemetryProvider connectionString={process.env.REACT_APP_APPINSIGHTS_CONNECTIONSTRING!}>
            {routes}
        </AITelemetryProvider>
    );
}

//  React 18 Render
const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            {routes}
        </BrowserRouter>
    </React.StrictMode>
);

//  If you want to start measuring performance in your app, pass a function
//  to log results (for example: reportWebVitals(console.log))
//  or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
